import styled from "styled-components";

const AppWrapper = styled.section`
    background: ${props => props.theme.colors.bg};
    background: linear-gradient(47deg, rgba(107,45,202,1) 0%, rgba(41,33,111,1) 100%);
    color: ${props => props.theme.colors.white};
    font-family: ${props => props.theme.fonts.primary};
    font-weight: 500;
    height: ${props => props.theme.gameSelectorWindow.height};
    overflow: hidden;
    opacity: ${props => props.loading ? '0.0001' : '1'};
    transform: ${props => props.loading ? 'scale(0.9)' : 'scale(1)'};
    transition: opacity ${props => props.theme.transition.durationLong} ${props => props.theme.transition.easeOut}, transform ${props => props.theme.transition.durationLong} ${props => props.theme.transition.easeOut};
    transition-delay: 0.1s;

    @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
        min-height: ${props => props.theme.gameSelectorWindow.minHeight};
    }
`;

export default AppWrapper;


// WEBPACK FOOTER //
// ./src/App/App.styled.js